import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import * as FaIcons from "react-icons/fa";
// import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";

export const SidebarData = [
  {
    title: "DASHBOARD",
    path: "/dashboard",
    icon: <IoIcons.IoIosArrowDown style={{ color: "#797979" }} />,
    cName: "nav-text",
  },
  {
    title: "CHATS",
    path: "/dashboard/messages",
    icon: <IoIcons.IoIosArrowDown style={{ color: "#797979" }} />,
    cName: "nav-text",
  },
  {
    title: "PROFILE",
    // dropDownOption: [
    //   {
    path: "/dashboard/account",
    name: "Update Profile",
    // className: "dropdown-option",
    //   },
    // ],
    icon: <IoIcons.IoIosArrowDown style={{ color: "#797979" }} />,
    cName: "nav-text",
  },
  {
    title: "NOTIFICATIONS",
    // dropDownOption: [
    //   {
    path: "/dashboard/notifications",
    name: "NOTIFICATIONS",
    // className: "dropdown-option",
    //   },
    // ],
    icon: <IoIcons.IoIosArrowDown style={{ color: "#797979" }} />,
    cName: "nav-text",
  },

  // {
  //   title: "UPDATE",
  //   path: "/dashboard/Account",
  //   icon: <IoIcons.IoIosArrowDown style={{ color: "#797979" }} />,
  //   cName: "nav-text",
  // },
  {
    title: "CONSULTATIONS",
    path: "/dashboard/allconsultations",
    icon: (
      <IoIcons.IoIosArrowDown style={{ height: "70px", color: "#797979" }} />
    ),
    cName: "nav-textq",
  },
];
